'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./forms.scss');
}

var Link   = ReactRouter.Link;

// var Constants = require('../constants');
// var Actions = require('../store').Actions;

var Submit = (props) => {
    return (
        <input type='submit' {...props} />
    );
};

// var InputText = (props) => {
//     return (
//         <input type        = "text"
//                valueLink   = {this.props.area}
//                placeholder = "MINIMUM 2,500" 
//                ref         = 'input'
//                onKeyDown  = {this.onKeyDown} />
//     );
// };

module.exports = {
    Button: require('./button.jsx'),
    Input: require('./input.jsx'),
    Radio: require('./radio.jsx'),
    Select: require('./select.jsx'),
    Submit: Submit,
};



// WEBPACK FOOTER //
// ./src/forms/forms.jsx